import { useEffect, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

interface AnimatedCounterProps {
  value: number;
  className?: string;
  duration?: number;
}

const AnimatedCounter = ({ value, className = "", duration = 1.5 }: AnimatedCounterProps) => {
  const [isAnimating, setIsAnimating] = useState(true);
  
  const spring = useSpring(0, {
    stiffness: 50,
    damping: 20,
    duration: duration * 1000,
  });

  const display = useTransform(spring, (current) =>
    Math.round(current).toLocaleString()
  );

  useEffect(() => {
    spring.set(value);
    const timeout = setTimeout(() => setIsAnimating(false), duration * 1000);
    return () => clearTimeout(timeout);
  }, [value, spring, duration]);

  return (
    <motion.span className={className}>
      {isAnimating ? <motion.span>{display}</motion.span> : value.toLocaleString()}
    </motion.span>
  );
};

export default AnimatedCounter;
